import axios from 'axios';

export const NOT_FOUND_PATH = '/404';
export const AXIOS_NOT_FOUND_REDIRECT_OPT_OUT = Object.freeze({
    skipNotFoundRedirect: true,
});

const normalizedPath = (path) => String(path || '/').replace(/\/+$/, '') || '/';

export const installAxiosNotFoundRedirect = ({navigate, getCurrentPath}) => {
    let active = true;
    let cleanedUp = false;

    const interceptorId = axios.interceptors.response.use(
        (response) => response,
        (error) => {
            const requestConfig = error?.config || error?.response?.config;
            const optedOut = requestConfig?.skipNotFoundRedirect === true;
            const alreadyOnNotFoundPage = normalizedPath(getCurrentPath?.()) === NOT_FOUND_PATH;

            if (
                active
                && Number(error?.response?.status) === 404
                && !optedOut
                && !alreadyOnNotFoundPage
            ) {
                navigate(NOT_FOUND_PATH, {replace: true});
            }

            return Promise.reject(error);
        }
    );

    return () => {
        if (cleanedUp) return;

        active = false;
        cleanedUp = true;
        axios.interceptors.response.eject(interceptorId);
    };
};
